module.exports = __webpack_public_path__ + "img/panch_cuento_2.7ca942d2.png";